/*
* This script handles the tabbing experience on the weather index page
* Its built to be both directly loaded or via unpoly
*/
// --- Main execution logic for the weather tabs script ---
const WEATHER_TAB_INITIALIZED_FLAG = 'data-weather-tab-initialized'; // A flag to prevent re-initialization
const unpolyTabs = false; //toggle for unpoly

if (window.up && window.up.version && unpolyTabs) {
    // Unpoly is available, use up.compiler for robust loading
    up.compiler('.weather-tabs', function(tabContainer) {
        if (tabContainer.hasAttribute(WEATHER_TAB_INITIALIZED_FLAG)) {
            return;
        }
        initializeWeatherTabs(tabContainer);
        tabContainer.setAttribute(WEATHER_TAB_INITIALIZED_FLAG, 'true');
    });

} else {
    // Unpoly is not available, fall back to DOMContentLoaded for initial page load
    document.addEventListener('DOMContentLoaded', () => {
        const tabContainers = document.querySelectorAll('.weather-tabs');
        tabContainers.forEach(tabContainer => {
            if (tabContainer.hasAttribute(WEATHER_TAB_INITIALIZED_FLAG)) {
                return;
            }
            initializeWeatherTabs(tabContainer);
            tabContainer.setAttribute(WEATHER_TAB_INITIALIZED_FLAG, 'true');
        });
    });
}

/**
 * Initializes the functionality for weather tabs within a given container.
 * This function is designed to be called by both DOMContentLoaded and Unpoly compilers.
 * @param {HTMLElement} tabContainer The HTML element containing the weather tabs.
 */
function initializeWeatherTabs(tabContainer) {
    if (!tabContainer) {
        return;
    }

    const tabLinks = tabContainer.querySelectorAll('.tab-link[data-tab]');
    // Note: tabContents are queried from the entire document, as they might not be direct children of the tabContainer
    const tabContents = document.querySelectorAll('.weather-tab-content-container .weather-tab[data-tab]');

    tabLinks.forEach(clickedLink => {
        // Unpoly often re-renders elements. To prevent duplicate event listeners,
        // it's good practice to ensure listeners are added only once or to use
        // delegated events (though for this specific case, the flag helps).
        // Unpoly's default behavior also often removes old listeners on re-render.
        clickedLink.addEventListener('click', function() {
            const tabIdToShow = this.dataset.tab;

            tabLinks.forEach(link => {
                link.classList.remove('active');
            });
            this.classList.add('active');

            tabContents.forEach(contentPanel => {
                contentPanel.classList.remove('active');
            });

            const contentToShow = document.querySelector(`.weather-tab-content-container .weather-tab[data-tab="${tabIdToShow}"]`);
            if (contentToShow) {
                updateUrlQueryParameter('mode', tabIdToShow);
                contentToShow.classList.add('active');
            }
        });
    });
}

/**
 * Updates or adds a query parameter to the current URL and pushes the new URL
 * to the browser's navigation history.
 *
 * @param {string} key The query parameter key to add or update.
 * @param {string} value The value for the query parameter.
 * @param {object} [stateData={}] Optional state object to associate with this history entry.
 * Defaults to an object containing the new key-value pair.
 * @param {string} [pageTitle=''] Optional title for the history entry (largely ignored by browsers).
 */
function updateUrlQueryParameter(key, value, stateData = null, pageTitle = '') {
    if (typeof window.URL === 'undefined' || typeof window.history.pushState === 'undefined') {
        return;
    }

    try {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set(key, value);
        const newUrlString = currentUrl.toString();

        if (window.location.href !== newUrlString) {
            const finalStateData = stateData !== null ? stateData : { [key]: value };
            window.history.pushState(finalStateData, pageTitle, newUrlString);
        }
    } catch (error) {}
}